export enum UIModule {
  MOBILE = "MOBILE",
  DESKTOP = "DESKTOP",
}
